import Container from "@/components/Container/Container.tsx";
import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";
import { PaymentResultType } from "@/stores/EngineStore/enums/PaymentResultType.ts";
import cn from "classnames";
import i18next from "i18next";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IoCheckmarkCircleSharp } from "react-icons/io5";
import { MdCancel } from "react-icons/md";
import { RiErrorWarningFill } from "react-icons/ri";
import { useShallow } from "zustand/react/shallow";

export const PaymentResult = () => {
  const { t } = useTranslation();
  const { paymentResult, setPage, setInquiryOverride } = useEngineStore(
    useShallow((state) => ({
      paymentResult: state.paymentResult,
      setPage: state.setPage,
      setInquiryOverride: state.setInquiryOverride,
    })),
  );

  // get i18next language from localstorage since it's lost in redirecting
  useEffect(() => {
    const language = localStorage.getItem("i18nextLng");
    if (language) void i18next.changeLanguage(language);
  }, []);

  const renderIcon = (type?: PaymentResultType | null) => {
    switch (type) {
      case PaymentResultType.Success:
        return <IoCheckmarkCircleSharp fill={"#197e00"} />;
      case PaymentResultType.Error:
        return <RiErrorWarningFill fill={"#cc0808"} />;
      case PaymentResultType.Cancellation:
        return <MdCancel fill={"#FFB700"} />;
    }
  };
  const renderTitle = (type?: PaymentResultType | null) => {
    if ((Object.values(PaymentResultType) as unknown[]).includes(type)) {
      return t(`paymentResult.title.${type}`);
    }
    return t("paymentResult.title.default");
  };

  const renderMessage = (type?: PaymentResultType | null) => {
    if ((Object.values(PaymentResultType) as unknown[]).includes(type)) {
      return t(`paymentResult.message.${type}`);
    }
    return t("paymentResult.message.default");
  };

  const handleBackToAllAcc = () => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete(URLParam.PaymentResult);
    history.replaceState(window.history.state, "", `${window.location.pathname}?${urlParams.toString()}`);
    setPage(AppPage.AccommodationPicking, "replace");
    setInquiryOverride(false);
  };

  return (
    <main className="o-page__inner">
      <section className="c-payment-result">
        <Container>
          <div className="c-payment-result-wrapper">
            <div
              className={cn({
                "c-payment-result__icon--canceled": paymentResult === PaymentResultType.Cancellation,
                "c-payment-result__icon--error": paymentResult === PaymentResultType.Error,
                "c-payment-result__icon": paymentResult === PaymentResultType.Success,
              })}
            >
              <div>{renderIcon(paymentResult)}</div>
            </div>
            <h1 className="c-payment-result__title">
              {renderTitle(paymentResult)} <br />
            </h1>
            <p className="c-payment-result__message">{renderMessage(paymentResult)}</p>
            <br />
            <button className="c-be-button" onClick={handleBackToAllAcc}>
              {t("backToSelAcc")}
            </button>
          </div>
        </Container>
      </section>
    </main>
  );
};
